module.exports = __webpack_public_path__ + "static/media/SpeedExamScreenshot.781d9711.png";